import { render, staticRenderFns } from "./MaterialVariantLocation.vue?vue&type=template&id=4b81180f&scoped=true"
import script from "./MaterialVariantLocation.vue?vue&type=script&lang=js"
export * from "./MaterialVariantLocation.vue?vue&type=script&lang=js"
import style0 from "./MaterialVariantLocation.vue?vue&type=style&index=0&id=4b81180f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b81180f",
  null
  
)

export default component.exports